import { PrebuiltTemplateShowcase } from '@/components/PrebuiltTemplateShowcase';

export function TemplateLibrary() {
  return <PrebuiltTemplateShowcase />;
}
